<div class="relative flex h-full flex-col" *transloco="let t">
  <div class="flex items-center justify-between px-3 py-2.5">
    <div class="flex w-[30rem] items-center gap-2">
      <input iInput [(ngModel)]="textFilter" size="sm" [placeholder]="t('catalog-page.search_product_or_brand')" />

      <app-compact-filter [filters]="filters() ?? []" (filterChange)="selectedFilters.set($event)" />
      <ISortSelect [sortByConfig]="sortByConfig" />
    </div>
    <div class="flex items-center gap-2">
      <button
        iButton
        [iDropdownMenuTrigger]="importMenu"
        placement="bottom-end"
        variant="secondary"
        [disabled]="!!isReadOnly()"
      >
        <IIcon name="import" />
        {{ t("common.import") }}
      </button>

      <ng-template #importMenu>
        <IDropdownMenu>
          <button iDropdownMenuItem (click)="bulkImportUnmanagedProducts(ImportManagedCatalogMode.MANAGED)">
            <IIcon name="packageCheck" />
            {{ t("catalog-page.import_managed_products") }}
          </button>
          <button iDropdownMenuItem (click)="bulkImportUnmanagedProducts(ImportManagedCatalogMode.UNMANAGED)">
            <IIcon name="packageMinus" />
            {{ t("catalog-page.import_unmanaged_product") }}
          </button>
        </IDropdownMenu>
      </ng-template>
      <button
        class="mat-mdc-tooltip-trigger group focus-visible:outline-main-400 ng-star-inserted relative m-0 flex shrink-0 grow-0 cursor-pointer items-center justify-center gap-x-1.5 rounded-lg border-none bg-white px-2 py-1 text-gray-900 opacity-100 shadow-[0px_0px_2px_#E0E0E0,0px_1px_4px_-2px_rgba(24,39,75,0.02),0px_4px_4px_-2px_rgba(24,39,75,0.06)] outline-hidden outline-offset-1 transition-[shadow,color,background-color] duration-200 hover:bg-[#FBFBFB] focus-visible:outline active:bg-[#FBFBFB] disabled:cursor-not-allowed disabled:opacity-75 disabled:hover:bg-white disabled:active:bg-white aria-disabled:cursor-not-allowed aria-disabled:opacity-75"
        [disabled]="!!isReadOnly()"
        (click)="
          toggleCatalogManagementMode(
            isAutoCatalogManagement() ? CatalogManagementMode.MANUAL : CatalogManagementMode.AUTO
          )
        "
      >
        <span class="text-sm font-medium text-slate-500"> {{ t("catalog-page.auto_catalog_management") }}</span>
        <IToggle [checked]="isAutoCatalogManagement()" size="sm" [disabled]="!!isReadOnly()" />
      </button>
    </div>
  </div>

  <div class="scrollbar min-h-0 flex-[1_1_0] overflow-auto">
    <table iTable>
      <thead iTableHead class="sticky top-0 left-0 z-50 border-none">
        <tr iTableRow>
          @let productsLength = filteredCatalog()?.length;
          <th iTableTh>
            <div class="flex items-center gap-2">
              @if (!isReadOnly() && filteredCatalog()?.length) {
                <ICheckbox [value]="isAllSelected()" (valueChange)="toggleSelectAllProducts()" class="mr-1.5" />
              }
              {{ t("common.asin") }}
              <IBadge [label]="productsLength?.toString() ?? '0'" color="gray" size="xs" />
            </div>
          </th>
          <th iTableTh>{{ t("common.product") }}</th>
          <th iTableTh>{{ t("common.brand") }}</th>
          <th iTableTh>{{ t("common.strategies") }}</th>
        </tr>
      </thead>
      <tbody iTableBody>
        @for (product of catalogPaginated(); track product.asin) {
          <tr
            iTableRow
            app-catalog-row
            [isManaged]="false"
            [product]="product"
            [isRowSelected]="selectedRows().has(product.asin!)"
            [ngClass]="{ 'bg-main-50 hover:!bg-main-50': selectedRows().has(product.asin!) }"
            (isRowSelectedChange)="onRowCheckboxClicked(product.asin!)"
          ></tr>
        }
      </tbody>
    </table>
  </div>

  <div>
    @if (unmanagedCatalog()?.length && unmanagedCatalog()!.length > DEFAULT_PAGE_SIZE) {
      <IPaginator
        [length]="unmanagedCatalog()?.length ?? 0"
        [pageIndex]="pagination().pageIndex"
        [pageSize]="pagination().pageSize"
        (paginationEvent)="pagination.set($event)"
        chatbotSafeArea
      />
    }
  </div>

  <app-catalog-toolbar [display]="selectedRowsCount() > 0 && !isReadOnly()">
    <ng-template>
      <div class="flex items-center gap-3.5">
        <div class="flex items-baseline gap-1">
          <IBadge [label]="selectedRowsCount().toString()" size="xs" />
          <span class="text-xs text-gray-600">selected</span>
        </div>
        <button iButton (click)="restoreManagingProducts()">
          <IIcon name="packagePlus" />
          {{ t("catalog-page.restore_managed_products") }}
        </button>
        <button iButton variant="ghost" [iTooltip]="'Clear selection'" (click)="clearSelection()">
          <IIcon name="close" />
        </button>
      </div>
    </ng-template>
  </app-catalog-toolbar>
</div>
